import { cn } from '@/app/_shared/lib/utils';
import type React from 'react';

interface UsageCardProps {
    title: string;
    text: string | React.ReactNode;
    Icon?: React.ElementType;
    className?: string;
}

export default function UsageCard({ title, text, Icon, className }: UsageCardProps) {
    return (
        <div className={cn('brand-gradient-border relative bg-surface-dark rounded-[16px] p-[25px]', className)}>
            <div className="flex items-center justify-center mb-3 relative z-10">
                {Icon ? (
                    <div className="bg-gradient-to-r from-brand-gradient-start to-brand-gradient-end p-2 rounded-full mr-3">
                        <Icon />
                    </div>
                ) : undefined}
                <h3 className="uppercase font-bold text-lg text-center">{title}</h3>
            </div>
            <p className="text-sm leading-[1.5] relative z-10">{text}</p>
        </div>
    );
}
